{{#> elements/_dt}}
  {{> elements/_label }}
{{/elements/_dt}}
{{#equal display_style 'radio'}}
  {{#each journey_subjects}}
    <dd>
      <input type="radio" name="{{../prefix}}[journey_subject_id]" id="journey_subject_id_{{this.value}}" {{#if ../value}}{{#equal this.value ../value}}checked{{/equal}}{{else}}{{#unless @index}}checked{{/unless}}{{/if}} value="{{this.value}}" />
      <label for="journey_subject_id_{{this.value}}">{{this.label}}</label>
    </dd>
  {{/each}}
{{else}}
  <dd>
    {{sp_select_tag (sp_select_name prefix "[journey_subject_id]")
      choices=select_items
      includeBlank=false
      searchable=select_searchable
      selected=value
      id=id
      required=required
      disabled=disabled
    }}
  </dd>
{{/equal}}
